import { useQuery } from "react-query";
import { getLeasedEquipmentMake } from "../../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipmentMake = () => {
  return useQuery("GetLeasedEquipmentMake", getLeasedEquipmentMake, {
    refetchOnWindowFocus: false,
  });
};
